"use client";

import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import HomeCard from "@/src/components/main-site/home/custom-mui/home-card/home-card";
import SectionHeader from "@/src/components/main-site/home/section-header/section-header";
import {Box, Link, Typography} from "@mui/material";
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar, faFileImage} from "@fortawesome/pro-duotone-svg-icons";
import Image from "next/image";
import {Navigation, Pagination} from "swiper/modules";
import NextLink from "next/link";

export default function LatestPostSection({posts}: { posts: any[] }) {

    return (
        <section id="posts" style={{padding: "1rem 0"}}>
            <HomeCard id="post-container">
                <SectionHeader
                    title="Latest Posts"
                    subtitle=" Discover our most recent insights and updates."
                />
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{clickable: true}}
                    spaceBetween={20}
                    slidesPerView={1}
                    slidesPerGroup={4}
                    breakpoints={{
                        640: {slidesPerView: 1},
                        768: {slidesPerView: 2},
                        1024: {slidesPerView: 3},
                        1280: {slidesPerView: 4},
                    }}
                >
                    {posts.map((post) => (
                        <SwiperSlide key={post?.id}>
                            <Box sx={{
                                backgroundColor: (theme) => theme.palette.custom?.homeSliderCardBackground,
                                padding: 1,
                                borderRadius: '8px',
                                display: 'flex', flexDirection: 'row', alignItems: 'stretch', gap: 1,
                            }}>
                                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'stretch', gap: 1}}>
                                    {post.image_url ? (
                                        <Image
                                            src={post.image_url}
                                            height={124}
                                            width={92}
                                            alt={post?.image_alt}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faFileImage} size="8x" width={92} height={124}/>
                                    )}

                                    <Link
                                        component={NextLink}
                                        href={post?.journal.is_main_site ? '/posts/' + post?.slug : '/journals/' + post?.journal.path + '/posts/' + post.slug}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'none',
                                            color: 'inherit',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <Typography
                                            component="h3"
                                            variant="fs5"
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {post?.title}
                                        </Typography>
                                        <Box sx={{
                                            display: 'flex', alignItems: 'center', gap: .3,
                                            color: (theme) => theme.palette.custom?.homePostDateColor,
                                        }}>
                                            <FontAwesomeIcon icon={faCalendar}/>
                                            <Typography sx={{
                                                color: (theme) => theme.palette.custom?.homePostColor,
                                                fontSize: '12px',
                                                display: '-webkit-box',
                                                lineHeight: '1.25rem',
                                                maxHeight: '3.75rem !important',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                flexGrow: 1,
                                                '& p': {
                                                    m: 0,
                                                },
                                            }}>
                                                {moment(post.publish_date).format("dddd MM,YYYY")}
                                            </Typography>
                                        </Box>
                                    </Link>
                                </Box>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </HomeCard>
        </section>
    );
}